$(document).ready(function () {
	if ($('.collections-page').length) {
		var triggers = document.querySelectorAll('[data-collection-toggle]');
		function closeItem(item) {
			if (!item) return;
			var trigger = item.querySelector('[data-collection-toggle]');
			var body = item.querySelector('.collection-item-body');
			item.classList.remove('is-open');
			if (trigger) trigger.setAttribute('aria-expanded', 'false');
			if (body) body.setAttribute('aria-hidden', 'true');
		}

		triggers.forEach(function (btn) {
			btn.addEventListener('click', function () {
				var targetId = this.getAttribute('data-collection-toggle');
				var body = document.getElementById(targetId);
				var item = document.getElementById('item-' + targetId);
				var isOpen = item.classList.contains('is-open');

				if (isOpen) {
					closeItem(item);
				} else {
					/*
					 * Legacy accordion mode (single-open).
					 * If client asks for old behavior, uncomment this block.
					 */
					/*
					document.querySelectorAll('.collection-item.is-open').forEach(function (openItem) {
						if (openItem !== item) closeItem(openItem);
					});
					*/
					item.classList.add('is-open');
					this.setAttribute('aria-expanded', 'true');
					body.setAttribute('aria-hidden', 'false');
				}
			});
		});
	}
});